import React from "react";
import OncologiaIconMini from "_+_Portal/assets/images/generico/OncologiaIconMini";
import "../../../pages/Oncología/Oncología.css";

const CardOncologia = () => {
  const AbrirFormularioOnco = () => {
    window.open(
      "https://my.forms.app/comunicacioniaf/oncologiaiafdim",
      "_blank"
    );
  };

  return (
    <React.Fragment>
      <div className="ptur-oncologia-headerCardOnco bgcG-latex30">
        <div style={{marginRight: 10, marginTop: 1}}>
          <OncologiaIconMini color={"var(--color-white)"} />
        </div>
        <div className="rb22b c-white">Oncología</div>
      </div>
      <div className="ptur-oncologia-recetaContainer">
        <div className="ptur-oncologia-texto1 rb16l c-grey55">
          <p>
            Siguiendo con nuestro propósito de mejorar la vida de las personas,
            tenemos el orgullo de anunciar nuestra alianza con el primer y más
            prestigioso Instituto de Oncología en América Latina: Alexander
            Fleming.
          </p>
        </div>
        <div className="ptur-oncologia-texto3 rb16l c-grey55">
          <p>
            Debido a la alta demanda, queremos darte una atención prioritaria.
            Si vos, un familiar o amigo tienen un diagnóstico oncológico y
            quieren continuar su tratamiento con nosotros, completá el siguiente
            formulario y nos contactaremos a la brevedad.
          </p>
        </div>
        <div className="ptur-oncologia-botonContainer">
          <button
            className="rb18m c-white bgcG-latex30 ptur-oncologia-boton"
            onClick={AbrirFormularioOnco}
          >
            Completar formulario
          </button>
        </div>
      </div>
    </React.Fragment>
  );
};

export default CardOncologia;
